export default "__VITE_ASSET__BsvDlG0P__"